import React from 'react';
import { IconProps } from '../types';

export const Email = ({ className }: IconProps) => {
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
      width="100%"
      height="100%"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M15.8593 3.17871L11.0068 7.99993L15.8593 12.8211C15.947 12.6378 16.0002 12.4351 16.0002 12.2187V3.78118C16.0002 3.56471 15.947 3.36205 15.8593 3.17871Z"
          fill="currentColor"
        />
        <path
          d="M14.5927 2.375H1.4052C1.18873 2.375 0.986078 2.42822 0.802734 2.51594L7.0047 8.68666C7.55308 9.23503 8.44483 9.23503 8.9932 8.68666L15.1952 2.51594C15.0118 2.42822 14.8092 2.375 14.5927 2.375Z"
          fill="currentColor"
        />
        <path
          d="M0.139961 3.17871C0.0522422 3.36205 -0.000976562 3.56471 -0.000976562 3.78118V12.2187C-0.000976562 12.4351 0.0522422 12.6378 0.139961 12.8211L4.99243 7.99993L0.139961 3.17871Z"
          fill="currentColor"
        />
        <path
          d="M10.3427 8.66309L9.65605 9.34974C8.74233 10.2635 7.25555 10.2635 6.34183 9.34974L5.6552 8.66309L0.802734 13.4843C0.986078 13.572 1.18873 13.6252 1.4052 13.6252H14.5927C14.8092 13.6252 15.0118 13.572 15.1952 13.4843L10.3427 8.66309Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
